export const NAV_LINKS = [
    { label: "Services", to: "/services" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
];

export const CAPABILITIES = [
    "Shopify",
    "React",
    "Node.js",
    "PHP",
    "WordPress",
    "REST APIs",
    "AI Solutions",
    "Web Applications",
];

export const SERVICES = [
    {
        num: "01",
        icon: "MonitorSmartphone",
        title: "Web Development",
        desc: "Modern, responsive websites and web applications engineered for performance and scalability.",
        long: "From marketing sites that load instantly to full web applications with complex state and integrations — we engineer front-ends and back-ends that stay fast under real-world traffic and remain easy to extend as your business grows.",
        tags: ["React", "JavaScript", "Performance"],
        deliverables: [
            "Marketing websites & product sites",
            "Web applications & portals",
            "CMS-driven websites",
            "Performance & Core Web Vitals optimization",
        ],
    },
    {
        num: "02",
        icon: "ShoppingBag",
        title: "eCommerce",
        desc: "Shopify development, custom storefronts, theme development, integrations and eCommerce optimization.",
        long: "We build Shopify experiences end to end: custom themes, headless storefronts, app integrations and checkout optimization — designed around conversion, merchandising flexibility and day-to-day operational simplicity.",
        tags: ["Shopify", "Storefronts", "Integrations"],
        deliverables: [
            "Shopify theme development",
            "Custom storefronts & headless builds",
            "App, payment & shipping integrations",
            "Conversion & checkout optimization",
        ],
    },
    {
        num: "03",
        icon: "LayoutDashboard",
        title: "Custom Software",
        desc: "Business applications, dashboards, portals and custom software built around unique workflows.",
        long: "When off-the-shelf tools don't fit, we design and build software around your exact workflows: internal tools, customer portals, dashboards and automation that remove manual work and give teams a single source of truth.",
        tags: ["Dashboards", "Portals", "Workflows"],
        deliverables: [
            "Internal tools & admin dashboards",
            "Customer & partner portals",
            "Workflow automation systems",
            "Legacy application modernization",
        ],
    },
    {
        num: "04",
        icon: "Cpu",
        title: "AI & Integrations",
        desc: "AI-powered features, APIs, automation and third-party integrations that connect your digital ecosystem.",
        long: "We connect your product to the systems around it — payment gateways, CRMs, logistics, analytics — and add AI where it genuinely saves time: assistants, search, classification and process automation.",
        tags: ["AI Features", "APIs", "Automation"],
        deliverables: [
            "AI-powered product features",
            "REST API design & development",
            "Third-party platform integrations",
            "Data pipelines & process automation",
        ],
    },
];

// Technology logos are served from the Simple Icons CDN by slug.
export const TECH_LOGOS = [
    { name: "React", slug: "react" },
    { name: "JavaScript", slug: "javascript" },
    { name: "HTML5", slug: "html5" },
    { name: "CSS", slug: "css" },
    { name: "Node.js", slug: "nodedotjs" },
    { name: "PHP", slug: "php" },
    { name: "Shopify", slug: "shopify" },
    { name: "WordPress", slug: "wordpress" },
];

export const TECH_EXTRA = [
    {
        label: "Integrations",
        icon: "Plug",
        items: ["REST APIs", "Third-party APIs", "Payment gateways", "CRM & analytics"],
    },
    {
        label: "AI",
        icon: "Sparkles",
        items: ["AI-powered applications", "Workflow automation", "Assistants & search"],
    },
];

export const PRINCIPLES = [
    {
        num: "01",
        title: "Business First",
        desc: "We understand the objective before writing the code.",
    },
    {
        num: "02",
        title: "Clean Engineering",
        desc: "Maintainable architecture and thoughtful implementation.",
    },
    {
        num: "03",
        title: "Performance",
        desc: "Fast, responsive experiences designed for real users.",
    },
    {
        num: "04",
        title: "Long-Term Thinking",
        desc: "We build systems that can evolve with the business.",
    },
];

export const PROCESS_STEPS = [
    { num: "01", title: "Discover", desc: "Understand the business, users and goals." },
    { num: "02", title: "Plan", desc: "Define scope, architecture and technical direction." },
    { num: "03", title: "Build", desc: "Design, develop and integrate the product." },
    { num: "04", title: "Test", desc: "Performance, usability, responsiveness and quality assurance." },
    { num: "05", title: "Launch", desc: "Deploy, monitor and support the product." },
];

// Real Shopify projects delivered by Apan Code Labs.
// Images live in /public/projects.
export const SHOPIFY_PROJECTS = [
    {
        num: "01",
        name: "Nano Jewellery",
        desc: "Shopify store design, development & optimisation.",
        tags: ["Shopify", "Store Design", "Optimisation"],
        image: "/projects/nano-jewellery.webp",
        url: "https://www.nano-jewelry.co.il/",
    },
    {
        num: "02",
        name: "Xtrema",
        desc: "Shopify speed optimisation & development using Liquid, jQuery, HTML and CSS.",
        tags: ["Shopify", "Liquid", "jQuery", "Speed"],
        image: "/projects/xtrema.webp",
        url: "https://xtrema.com/",
    },
    {
        num: "03",
        name: "Divers Alert Network",
        desc: "Complete Shopify store design & development.",
        tags: ["Shopify", "Store Design", "Development"],
        image: "/projects/divers-alert-network.webp",
        url: "https://shop.dan.org/",
    },
    {
        num: "04",
        name: "Hero Sunglasses",
        desc: "Custom Shopify store development from Figma design.",
        tags: ["Shopify", "Figma to Store", "Custom Build"],
        image: "/projects/hero-sunglasses.webp",
        url: "https://www.herosunglasses.com/",
    },
    {
        num: "05",
        name: "Your Cat Back Pack",
        desc: "Shopify custom app development & speed optimisation.",
        tags: ["Shopify", "Custom App", "Speed"],
        image: "/projects/your-cat-backpack.webp",
        url: "https://yourcatbackpack.com/",
    },
    {
        num: "06",
        name: "Body Heal",
        desc: "Shopify health custom store development.",
        tags: ["Shopify", "Health", "Custom Store"],
        image: "/projects/body-heal.webp",
        url: "https://www.bodyheal.com.au/",
    },
];

// Sample placeholder testimonials — replace with real client feedback
// (name, role, company, quote) as engagements complete.
export const TESTIMONIALS = [
    {
        quote: "They understood the business goal before writing a single line of code. The site launched on time and immediately felt faster for our customers.",
        name: "Client Name",
        role: "Founder, eCommerce Brand",
    },
    {
        quote: "Clear communication, honest timelines, and engineering that didn't need to be re-done six months later. Exactly what we needed.",
        name: "Client Name",
        role: "Operations Lead, Services Business",
    },
    {
        quote: "Our internal dashboard replaced three spreadsheets and a weekly status meeting. The team thinks in workflows, not just screens.",
        name: "Client Name",
        role: "Product Manager, SaaS Company",
    },
];

// Placeholder — replace with the configured inbox when ready.
export const CONTACT_EMAIL = "hello@apancodelabs.com";

// Placeholders — swap in real profile URLs when available.
// slug = Simple Icons CDN slug; null falls back to a lucide icon.
export const SOCIALS = [
    { label: "LinkedIn", url: null, slug: null },
    { label: "GitHub", url: null, slug: "github" },
    { label: "Upwork", url: null, slug: "upwork" },
];

export const PROJECT_TYPES = [
    "Website",
    "eCommerce / Shopify",
    "Web Application",
    "Custom Software",
    "AI / Integrations",
    "Not sure yet",
];
